import IProject from "../../types/project";
import { apiPost } from "../../api/api";

export const REQUEST_collections = "REQUEST_collections";
export const RECEIVE_collections = "RECEIVE_collections";

export function addProject(project: IProject) {
  return apiPost(`/projects`, project);
}
